import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CapacitacionRoutingModule } from './capacitacion-routing.module';
import { CapacitacionComponent } from './capacitacion.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HttpClientModule } from '@angular/common/http';
import { ModalInfoComponent } from '../components/modal-info/modal-info.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    CapacitacionComponent,
    DashboardComponent,
    ModalInfoComponent
  ],
  imports: [
    CommonModule,
    CapacitacionRoutingModule,
    HttpClientModule,
    FormsModule
  ]
})
export class CapacitacionModule { }
